export default {
    namespaced: true,

    state: {
        filterState: null
    },

    mutations: {
        setFilterState(state, value) {
            let emptyFilter = true;

            value.forEach(element => {
                if (element.model) emptyFilter = false;
            });

            if (!emptyFilter) state.filterState = value;
            else state.filterState = null;
        },

        clearFilterState(state) {
            state.filterState = null;
        }
    },
};